module.exports = "https://static.wmbcdn.com/uniweb/images/c90d8eaf29583f0c12327c81dbfd79b5.svg";